import {Component, HostBinding, Injector, Input, ViewEncapsulation} from '@angular/core';
import {TagTextData} from '../tag-text/tag-text.component';
import { ButtonOptions } from '../eva-button/eva-button.component';
import { AbstractComponent } from '../abstract.component';
import { TextAlign } from 'projects/common/model/ModuleModel';

export interface TextData {
  text_data?: TagTextData;
  pretitle?: TagTextData;
  title?: TagTextData;
  subtitle?: TagTextData;
  button_options?: ButtonOptions;
  text_horizontal_align?: TextAlign;
}

@Component({
  selector: 'text',
  template: `
    <div class="content-wrapper text-align-{{data.text_horizontal_align}}" 
      [ngClass]="{
        'vertical-align-top': verticalAlign === 'TOP', 
        'vertical-align-center': verticalAlign === 'CENTER', 
        'vertical-align-bottom': verticalAlign === 'BOTTOM'}"
      >
      <tag-text *ngIf="data.pretitle?.text" class="pretitle-content eva-3-overline-1" [data]="data.pretitle"></tag-text>
      <tag-text *ngIf="data.title?.text" class="title-content" [data]="data.title"></tag-text>
      <tag-text *ngIf="data.subtitle?.text" class="subtitle-content" [data]="data.subtitle"></tag-text>
      <tag-text *ngIf="data.text_data?.text" class="text-content" [data]="data.text_data"></tag-text>
      <eva-button *ngIf="showButton && data.button_options" class="button-container -eva-3-mt-lg" [options]="data.button_options"
        [moduleId]="moduleId" [moduleIndex]="moduleIndex" [uniqueId]="uniqueId"></eva-button>
    </div>
  `,
  styleUrls: ['./text.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TextComponent extends AbstractComponent {
  @Input() uniqueId?: string;
  @Input() moduleId: string;
  @Input() moduleIndex: number;
  @Input() data: TextData;
  @Input() showButton: boolean = true;
  @Input() verticalAlign?: 'TOP' | 'CENTER' | 'BOTTOM' = 'TOP';

  constructor(injector: Injector) {
    super(injector);
  }

  getModuleId(): string {
    return "TextComponent";
  }

  @HostBinding('class.vertical-align-center') 
  get isCenterAligned() {
    return this.verticalAlign === 'CENTER';
  }
}
